import { render } from "./SideMenuArea.vue?vue&type=template&id=08522945&scoped=true"
import script from "./SideMenuArea.vue?vue&type=script&lang=js"
export * from "./SideMenuArea.vue?vue&type=script&lang=js"

import "./SideMenuArea.vue?vue&type=style&index=0&id=08522945&scoped=true&lang=stylus"

import exportComponent from "C:\\Users\\DGWA\\Documents\\tokyo-shoseki_R8_042024\\08k\\08k_sigb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08522945"]])

export default __exports__